'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Pagination": "Polaris-Pagination",
  "table": "Polaris-Pagination--table",
  "TablePaginationActions": "Polaris-Pagination__TablePaginationActions"
};

exports.default = styles;
